import styled from 'styled-components'

interface StatusPillProps {
  color: string
}

export const StatusPillContent = styled.div<StatusPillProps>`
  border-radius: 20px;
  background-color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  padding: 5px 10px 5px 10px;
  align-items: center;
`

export const StatusText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textPill};
`
